import React from "react";
import Breadcrumb from "../../Components/Breadcrumb/Breadcrumb";
import AllAcountsSection from "../../Components/AllAccountsSection/AllAcountsSection";
import SavePlusAccountComponent from "../../Components/SavePlusAccount/SavePlusAccountComponent";
import { AiOutlineArrowRight } from "react-icons/ai";
import { useEffect } from "react";

import IndoKaSumfinAccordion from "./IndoKaSumfinAccordion";
import { question } from "./IndoKaSumfinData";

const IndoKaSumfinLoan = () => {
  const img1 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/EC7A7020IZB%20Photo.JPG";
  const Arrow_down = "https://izbassetsmain.blob.core.windows.net/izbwebassets/arrow_down.png";
  const BackgroundBrundcrumb = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Indo%20Ka%20Sumfin%20Loan_Cover.png";

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const accountContent = "The Indo Ka Sumfin Loan is a working capital term loan designed to support businesses. It offers financing of up to ZMW 10,000, with flexible repayment options and no collateral requirement. This product is tailored to help business owners restart or grow their enterprises, while promoting timely repayment and the use of digital transactions.";

  return (
    <>
      <Breadcrumb
        Heading="Indo Ka Sumfin Loan"
        img={BackgroundBrundcrumb}
        show={true}
        btnTxt="Apply Now"
      />
      <SavePlusAccountComponent
        heading="Indo Ka Sumfin Loan"
        subHeading="Know About"
        content={accountContent}
        btnTxt="Apply Now"
        img={img1}
        logo={true}
      />

      <section id="IndoKaSumfinAccordion">
        <div className="container justify-content-center mt-5">
          <div className="faq-style1__content">
            <ul className="accordion-box my-5">
              {question.map((item) => {
                const { id } = item;
                return <IndoKaSumfinAccordion key={id} {...item} />;
              })}
            </ul>
          </div>
        </div>
      </section>

      <div className="container">
        <div
          className="bg-light my-3"
          style={{
            padding: "20px 0px 20px 60px",
          }}
        >
          <h6 style={{ color: "#9E1B1E" }}>Terms and Conditions Apply</h6>
        </div>
      </div>
      <AllAcountsSection />
    </>
  );
};

export default IndoKaSumfinLoan;
